import React from 'react'
import styled, { keyframes } from 'styled-components'
import { ToastContainer } from 'react-toastify'
/* CONSTANTS */
import { CLIENT_STYLINGS, size } from '../../../../utils/constants'
import { getBorderRadius } from '../../../../utils/styleUtils'

export const ImageWrapper = styled.img``

const loadingFade = keyframes`
  0% { opacity: 0; }
  50% {opacity: 0.8; }
  100% { opacity: 0; }
`

export const MayaPageWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  overflow-y: hidden;
  background: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  @media (max-width: ${size.laptop}) {
    padding: 0px 0px;
    padding-bottom: 15px;
    height: calc(100% - 48px);
    max-height: calc(100% - 48px);
  }
`

export const AiPlannerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border-radius: ${props => getBorderRadius(props, 'xl')};
  @media (max-width: ${size.laptop}) {
    height: 100%;
    max-height: 100%;
  }
`

export const AiPlannerContainer = styled.div`
  display: flex;
  height: 100%;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
`

export const ChatSectionWrapper = styled.div`
  width: 47%;
  position: relative;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};

  @media (max-width: ${size.laptop}) {
    width: 100%;
  }

  -webkit-transition: width 0.5s ease;
  -moz-transition: width 0.5s ease;
  -o-transition: width 0.5s ease;
  transition: width 0.5s ease;
`

export const ChatSectionScrollable = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  padding: 32px 24px 24px 24px;
  height: 100%;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};

  @media (max-width: ${size.laptop}) {
    padding: 16px 12px;

    @supports (-webkit-touch-callout: none) {
      padding-bottom: 180px; /* Extra padding to account for fixed input */
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
`

export const IntentWrapper = styled.div`
  width: 53%;
  position: relative;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  border: ${props =>
    props?.isContent
      ? `1px solid ${
          CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER
        }`
      : 'none'};
  margin-bottom: 0px;

  @media (max-width: ${size.laptop}) {
    width: 100%;
    border-radius: ${props => getBorderRadius(props, 'md')};
  }
`

export const ShowIntentWrapper = styled.div`
  height: 100%;
`

export const IntentRecommendationWrapper = styled.div`
  padding: 15px;
  position: relative;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  overflow-y: ${props => (props?.$canScroll ? `scroll` : 'hidden')};
  height: 100%;
  padding-bottom: 110px;
  border: ${props =>
    props?.isContent
      ? `1px solid ${
          CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER
        }`
      : 'none'};

  @media (max-width: ${size.laptop}) {
    border-radius: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].BORDERS_ROUNDED
        ? '10px'
        : '0px'};
  }

  &::-webkit-scrollbar {
    display: block;
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  }
`

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 22px;
`

export const MessageContentContainer = styled.div`
  display: flex;
  align-self: ${props => props?.sender && 'flex-end'};
`

export const FeedbackContainer = styled.div`
  margin-top: 5px;
  display: flex;
  align-self: flex-start;
  margin-bottom: ${props => (props?.removeMarginBottom ? '0px' : '22px')};
  margin-left: 52px;
`

export const LeaveFeedbackText = styled.span`
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  font-size: 12px;
`

export const FeedbackIconWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover .tooltip-text {
    visibility: visible;
  }
`

export const FeedbackIconTooltipText = styled.span`
  visibility: hidden;
  width: max-content;
  top: 100%;
  left: 50%;
  transform: translateX(-50%); /* Dynamically offset by 50% of width */
  padding: 3px;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  text-align: center;
  border-radius: ${props => getBorderRadius(props, 'sm')};
  font-size: 12px;

  position: absolute;
  z-index: 1;
`

export const FeedbackIcon = styled.svg`
  color: ${props =>
    props?.saved
      ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY_FOREGROUND
      : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  cursor: ${props => (props?.saved ? 'default' : 'pointer')};
  margin: 0px 2px;
  fill: ${props =>
    props?.saved
      ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY_FOREGROUND
      : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};

  &:hover {
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY_FOREGROUND};
    fill: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY_FOREGROUND};
  }
`

export const DisclaimerMessage = styled.span`
  font-style: italic;
  font-size: 11px;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  color: ${props =>
    props?.hasHallucination
      ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.DESTRUCTIVE ||
        CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.ERROR
      : props?.sender
      ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND
      : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};

  a {
    color: #4183c4;
    text-decoration: none;
    background-color: transparent;
    font-size: 11px !important;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  }
`

export const HallucinationDisclaimerMessage = styled.span`
  font-style: italic;
  font-size: 14px;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.DESTRUCTIVE ||
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.ERROR};
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
`

export const MessageTextContainer = styled.div`
  text-align: left;
  padding: 10px 18px;
  margin: ${props => (props?.sender ? '0 0 0 120px' : '0 120px 0 12px')};
  border-radius: ${props => getBorderRadius(props, 'lg')};
  border: none;
  color: ${props =>
    props?.sender
      ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER_FOREGROUND
      : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
          .ASSISTANT_FOREGROUND};
  background-color: ${props =>
    props?.sender
      ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER
      : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.ASSISTANT};
  font-size: 14px;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  white-space: pre-line;
  min-width: 50px;
  word-wrap: break-word;

  @media (max-width: ${size.laptopL}) {
    margin: ${props => (props?.sender ? '0 0 0 40px' : '0 40px 0 12px')};
  }

  @media (max-width: ${size.laptop}) {
    margin: 0 12px;
  }

  overflow-x: auto;

  table {
    border-collapse: collapse; /* Ensures borders are not doubled */
    width: 100%; /* Optional: Makes the table full width */
  }

  tr,
  th {
    border-bottom: 1px solid
      ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER}; /* Adds a border between rows */
  }

  th,
  td {
    padding: 8px; /* Adds spacing inside cells */
    text-align: left; /* Aligns text to the left */
  }

  /* Optional: Remove border from the last row */
  tr:last-child {
    border-bottom: none;
  }

  th {
    font-size: 14px;
    line-height: 22px;
    font-weight: 700;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
    color: ${props =>
      props?.sender
        ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER_FOREGROUND
        : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
            .ASSISTANT_FOREGROUND};
  }

  td {
    font-size: 14px;
    line-height: 22px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
    color: ${props =>
      props?.sender
        ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER_FOREGROUND
        : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
            .ASSISTANT_FOREGROUND};
  }

  li p + ul,
  li p + ol {
    padding-top: 0 !important;
  }

  ol {
    padding-top: 10px;
    list-style-type: decimal;
    padding-inline-start: 20px;
    margin-block-start: 0px;
    margin-block-end: 0px;
    color: ${props =>
      props?.sender
        ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER_FOREGROUND
        : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
            .ASSISTANT_FOREGROUND};
    font-size: 14px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
    white-space: normal;
  }

  ul {
    padding-top: 10px;
    padding-inline-start: 20px;
    margin-block-start: 0px;
    margin-block-end: 0px;
    color: ${props =>
      props?.sender
        ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER_FOREGROUND
        : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
            .ASSISTANT_FOREGROUND};
    font-size: 14px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
    white-space: normal;
  }

  li {
    margin-block-start: 0px;
    margin-block-end: 0px;
    color: ${props =>
      props?.sender
        ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER_FOREGROUND
        : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
            .ASSISTANT_FOREGROUND};
    font-size: 14px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
    white-space: normal;
    p {
      padding-bottom: 10px;
      display: block;
    }
  }

  li:not(:last-child) {
    padding-bottom: 10px;
  }

  li {
    li:not(:last-child) {
      padding-bottom: 10px;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    display: inline-block;
    margin-top: 10px;
    margin-bottom: 5px;
  }

  hr {
    display: none;
  }

  p {
    margin-block-start: 0px;
    margin-block-end: 0px;
    display: block;
    margin: 0px;
    padding: 0px;

    color: ${props =>
      props?.sender
        ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER_FOREGROUND
        : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
            .ASSISTANT_FOREGROUND};
    font-size: 14px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  }

  a {
    color: ${props =>
      props?.sender
        ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER_FOREGROUND
        : '#4183c4'};
    text-decoration: none;
    background-color: transparent;
    font-size: 14px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};

    font-weight: ${props => (props?.sender ? 'bold' : 'normal')};
    text-decoration: ${props => (props?.sender ? 'underline' : 'none')};
  }

  strong {
    color: ${props =>
      props?.sender
        ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER_FOREGROUND
        : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
            .ASSISTANT_FOREGROUND};
    font-size: 14px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
    font-weight: bold;
  }
`

export const MessageAvatarContainer = styled.div``

export const MayaInputBox = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};

  @media (max-width: ${size.laptop}) {
    @supports (-webkit-touch-callout: none) {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1000;
    }
  }
`

export const MayaInputContainerWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
  z-index: 9;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};

  @media (max-width: ${size.laptop}) {
    @supports (-webkit-touch-callout: none) {
      position: relative;
      padding-bottom: env(safe-area-inset-bottom);
    }
  }
`

export const MayaInputContainer = styled.div`
  margin: auto;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  width: 93%;
  position: relative;
`

export const MayaMessageInput = styled.textarea`
  width: 100%;
  height: 90px;
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  border-radius: ${props => getBorderRadius(props, 'lg')};
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  padding: 12px 60px 12px 12px;
  resize: none;
  font-size: 14px !important;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};

  @media (max-width: ${size.laptop}) {
    font-size: 16px !important;
    height: ${props => (props.isHorizontal ? '70px' : '90px')};

    /* iOS specific fixes */
    @supports (-webkit-touch-callout: none) {
      padding-bottom: env(safe-area-inset-bottom);
      margin-bottom: 0;
    }
  }

  @media (max-width: ${size.mobileM}) {
    font-size: 16px !important;
    height: 70px;
  }

  /* iOS-specific fixes */
  @supports (-webkit-touch-callout: none) {
    font-size: 16px !important; /* Prevent automatic zoom */
    -webkit-appearance: none; /* Remove default iOS styling */
    -moz-appearance: none;
    appearance: none;
  }

  &:focus {
    outline: none !important;
    border: 2px solid
      ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  }
  &:hover {
    cursor: pointer;
  }
`

export const MayaMessageInputSubmitButton = styled.button`
  position: absolute;
  right: 10px;
  bottom: 30px;
  background: none;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER_FOREGROUND};
  border-radius: ${props => getBorderRadius(props, 'lg')};
  flex-shrink: 0;
  overflow: hidden;
  border: none;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: ${props => (props.$disabled ? 'none' : 'auto')};
  opacity: ${props => (props.$disabled ? 0.75 : 1)};
  padding: 0px;
  transition: opacity 0.1s;

  &:hover {
    opacity: 0.75;
  }

  &:after {
    content: none;
  }
  &:before {
    content: none;
  }
`

export const MayaMobileTabsWrapper = styled.div`
  display: flex;
  width: 100vw;
  height: 48px;
  position: sticky;
  top: 0px;
  z-index: 9;
  background: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
`

export const MayaMobileTabs = styled.div`
  display: flex;
  width: ${props => (props.$showSecondTab ? '50%' : '100%')};
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 700;
  color: ${props =>
    props.active
      ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY
      : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  border-bottom: ${props =>
    props?.active
      ? `2px solid ${
          CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY
        }`
      : 'none'};
`

export const MayaQuickRepliesConatiner = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-right: 120px;
  justify-content: flex-end;
  margin-bottom: 22px;

  @media (max-width: ${size.laptopL}) {
    padding-right: 40px;
  }

  @media (max-width: ${size.laptop}) {
    padding-right: 12px;
  }
`

export const MayaQuickRepliesBullet = styled.div`
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  padding: 5px 10px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  margin: 0 0px 10px 10px;
  text-align: left;
  background: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};

  &:hover {
    background-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY};
    cursor: pointer;
  }
`

// Create the animation
const colorPulse = keyframes`
  0%, 100% {
    background-position: 0% center;
    opacity: 0.8;
  }
  50% {
    background-position: 100% center;
    opacity: 1;
  }
`

export const ReasoningText = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  font-size: 14px;
  font-weight: 500;
  background: linear-gradient(
    90deg,
    #555555,
    #777777,
    #999999,
    #bbbbbb,
    #999999,
    #777777,
    #555555
  );
  background-size: 200% auto;
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  animation: ${colorPulse} 3s ease-in-out infinite;
  display: inline-block;
`

export const TypingContainer = styled.div`
  width: 50em;
  height: 2em;
  position: relative;
  padding: 10px;
  margin-left: 5px;
  margin-top: 8px;
  display: flex;
  align-items: center;
  border-radius: ${props => getBorderRadius(props, 'xl')};
`

export const TypingContainerInInput = styled.div`
  width: 4em;
  height: 2em;
  position: relative;
  padding: 10px;
  margin-left: 5px;
  margin-top: 8px;
  border-radius: ${props => getBorderRadius(props, 'xl')};
`

export const TypingDot = styled.div`
  float: left;
  width: 6px;
  height: 6px;
  margin: 0 4px;
  background: rgba(0, 0, 0, 0.54);
  border-radius: 50%;
  opacity: 0;
  animation: ${loadingFade} 1s infinite;

  :nth-child(1) {
    animation-delay: 0s;
  }
  :nth-child(2) {
    animation-delay: 0.3s;
  }
  :nth-child(3) {
    animation-delay: 0.6s;
  }
`

export const NotificationDot = styled.div`
  width: 8px;
  height: 8px;
  margin: 0 4px;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.DESTRUCTIVE ||
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.ERROR};
  border-radius: 50%;
`

export const RegenerateResponse = styled.div`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 14px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY_FOREGROUND};
  padding: 8px;
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  border-radius: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].BORDERS_ROUNDED
      ? '5px'
      : '0px'};
  align-self: center;
  cursor: pointer;
  text-align: center;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};

  &:hover {
    background-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY};
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
    border: 1px solid
      ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  }
  &:active {
    border: 2px solid
      ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  }
  margin-top: 20px;
`

export const UserInputContainer = styled.div`
  padding: 20px;
  background: rgba(0, 113, 138, 0.15);
  border-radius: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].BORDERS_ROUNDED
      ? '10px'
      : '0px'};
  display: flex;
  flex-direction: column;
  width: ${props => (props.isMayaFullScreen ? '35%' : '100%')};

  @media (max-width: ${size.laptop}) {
    width: 100%;
  }
`

export const MayaAvatar = styled(Image)`
  width: 200px;
  height: 200px;

  @media (max-width: ${size.tablet}) {
    width: 150px;
    height: 150px;
  }
`

export const IntentBackgroundImg = styled.img`
  color: transparent;
  object-fit: cover;
  width: 100%;
  height: 100%;
`

export const StyledToastContainer = styled(ToastContainer)`
  .Toastify__toast {
    background: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
    border-radius: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].BORDERS_ROUNDED
        ? '5px'
        : '0px'};
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
    font-weight: normal;
    font-size: 12px;
    z-index: 100;
    display: inline-flex;
    max-width: ${size.mobileS};
    float: right;
    margin: 5px;
  }

  .Toastify__toast-body {
    padding: 0px 15px;
  }

  .Toastify__close-button {
    float: right;
    margin: 5px;
  }
`

export const ChatSectionCtaWrapper = styled.div`
  z-index: 9;
  bottom: 0px;
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-self: center;
  padding-bottom: 10px;
`

export const ChatSectionCta = styled.button`
  white-space: normal;
  flex: 0 0 49%;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border-style: solid;
  border-width: 2px;
  border-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  border-radius: ${props => getBorderRadius(props, 'sm')};
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  cursor: pointer;
  padding: 5px 10px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  text-decoration: none;
  align-self: center;
  align-self: stretch;

  @media (max-width: ${size.mobileM}) {
    font-size: 12px;
  }

  &:after {
    content: none;
  }
  &:before {
    content: none;
  }

  &:disabled {
    background-color: #cccccc;
    color: #666666;
    cursor: not-allowed;
    opacity: 0.6;
    border: 1px solid #999999;

    &:hover {
      background-color: #cccccc;
      color: #666666;
      border: 1px solid #999999;
    }
  }

  &:hover {
    background-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  }

  transition: background-color 0.3s ease;

  svg {
    color: inherit;
    fill: white;
  }
`

export const ChatSectionCtaLink = styled.a`
  white-space: normal;
  flex: 0 0 49%;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border-style: solid;
  border-width: 2px;
  border-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  border-radius: ${props => getBorderRadius(props, 'sm')};
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  cursor: pointer;
  padding: 5px 10px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  text-decoration: none;
  align-self: center;
  align-self: stretch;

  @media (max-width: ${size.mobileM}) {
    font-size: 12px;
  }

  &:after {
    content: none;
  }
  &:before {
    content: none;
  }

  &:hover {
    background-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  }

  transition: background-color 0.3s ease;
`
export const ShowIntentCtaWrapper = styled.div`
  min-height: 50px;
  position: sticky;
  bottom: 0;
  padding: 5px 0px 35px 0px;
  background: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  @media (max-width: ${size.mobileXL}) {
    padding: 5px 10px 35px 10px;
  }
`

export const RequestPlanCtaWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`

export const RequestPlanCta = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border-style: solid;
  border-width: 1px;
  border-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  border-radius: ${props => getBorderRadius(props, 'sm')};
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  cursor: pointer;
  padding: 7px 10px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  text-decoration: none;
  align-self: center;
  bottom: 0px;
  width: 45%;
  margin: 10px auto;
  align-self: stretch;

  @media (max-width: ${size.laptop}) {
    font-size: 14px;
    margin: 5px 5px;
  }

  @media (max-width: ${size.tablet}) {
    width: 50%;
  }

  -webkit-transition: 0.25s ease;
  -moz-transition: 0.25s ease;
  -o-transition: 0.25s ease;
  transition: 0.25s ease;

  &:hover {
    transform: scale(1.025);
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
    background-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  }

  &:after {
    content: none;
  }
  &:before {
    content: none;
  }

  &:disabled {
    background-color: #cccccc;
    color: #666666;
    cursor: not-allowed;
    opacity: 0.6;
    border: 1px solid #999999;
  }
`

export const RequestPlanCtaLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border-style: solid;
  border-width: 1px;
  border-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  border-radius: ${props => getBorderRadius(props, 'sm')};
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  cursor: pointer;
  padding: 7px 10px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  text-decoration: none;
  align-self: center;
  bottom: 0px;
  width: 45%;
  margin: 10px auto;
  align-self: stretch;

  @media (max-width: ${size.laptop}) {
    font-size: 14px;
    margin: 5px 5px;
  }

  @media (max-width: ${size.tablet}) {
    width: 50%;
  }

  -webkit-transition: 0.25s ease;
  -moz-transition: 0.25s ease;
  -o-transition: 0.25s ease;
  transition: 0.25s ease;

  &:hover {
    transform: scale(1.025);
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
    background-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  }

  &:after {
    content: none;
  }
  &:before {
    content: none;
  }
`

export const MayaEmptyMarginContainer = styled.div`
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  height: ${process.env.REACT_APP_API_ENV === 'production' ? '0px' : '35px'};
  @media (max-width: ${size.laptop}) {
    height: ${process.env.REACT_APP_API_ENV === 'production' ? '0px' : '50px'};
  }
`

export const IconsRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  right: 40px;
  @media (max-width: ${size.laptop}) {
    bottom: 0;
  }
`

export const RefreshIconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY} !important;
    fill: none !important;
    stroke: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY} !important;
    stroke-width: 2 !important;
  }

  svg * {
    fill: none !important;
    stroke: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY} !important;
    stroke-width: 2 !important;
  }
`

export const RefreshIconMobileWrapper = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;

  svg {
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY} !important;
    fill: none !important;
    stroke: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY} !important;
    stroke-width: 2 !important;
  }

  svg * {
    fill: none !important;
    stroke: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY} !important;
    stroke-width: 2 !important;
  }
`

// Share icon wrappers (placed left of Refresh icon)
export const ShareIconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY} !important;
    fill: none !important;
    stroke: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY} !important;
    stroke-width: 2 !important;
  }

  svg * {
    fill: none !important;
    stroke: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY} !important;
    stroke-width: 2 !important;
  }
`

export const ShareIconMobileWrapper = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;

  svg {
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY} !important;
    fill: none !important;
    stroke: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY} !important;
    stroke-width: 2 !important;
  }

  svg * {
    fill: none !important;
    stroke: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY} !important;
    stroke-width: 2 !important;
  }
`
export const PoweredByMayaWrapper = styled.div`
  width: 93%;
  position: relative;
  margin: auto;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 12px;
  font-weight: 600;
  line-height: 12px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  text-align: right;

  @media (min-width: ${size.laptop}) {
    position: absolute;
    bottom: 10px;
    width: 100%;
    text-align: center;
  }
`

export const PoweredByMayaText = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
`

export const PoweredByMayaLink = styled.a`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  line-height: 12px;
  font-size: 12px;
  font-weight: 700;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  cursor: pointer;
`

export const ReadOnlyDisclaimerWrapper = styled.div`
  position: absolute;
  bottom: 20px;
  width: 95%;
  margin: 0 auto;
  right: 0;
  left: 0;
  padding: 30px 15px;
  font-size: 14px;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  border-radius: ${props => getBorderRadius(props, 'sm')};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
`
